import { render, staticRenderFns } from "./TaskSelectModal.vue?vue&type=template&id=594f1886&scoped=true"
import script from "./TaskSelectModal.vue?vue&type=script&lang=js"
export * from "./TaskSelectModal.vue?vue&type=script&lang=js"
import style0 from "./TaskSelectModal.vue?vue&type=style&index=0&id=594f1886&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594f1886",
  null
  
)

export default component.exports